const workNav = document.querySelector("#work-nav");

if (workNav) {
  const workSection = document.querySelector(".work-section");
  const workSectionHeight = workSection.offsetHeight;

  workNav.style.transform = `translate(-50%, -${workSectionHeight / 2}px)`;
}